import { render, staticRenderFns } from "./SalesAnalysis.vue?vue&type=template&id=599e961c&scoped=true&"
import script from "./SalesAnalysis.vue?vue&type=script&lang=js&"
export * from "./SalesAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SalesAnalysis.vue?vue&type=style&index=0&id=599e961c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e961c",
  null
  
)

export default component.exports